module.exports = "/_next/static/images/game-1-phone-gallery-08-21-1402-uv-b7cdc040dddf3f7ad77d0ee81f315543.jpg";